import { Builder } from "@builder.io/react";

import { BuilderButton } from "./BuilderButton";

export const registerBuilderButton = () => {
  Builder.registerComponent(BuilderButton, {
    name: "Button",
    hideFromInsertMenu: false,
    // to make sure button is not wrapped in a div
    noWrap: true,
    inputs: [
      {
        name: "textContent",
        type: "string",
        defaultValue: "Button Text",
        localized: true,
      },
      {
        name: "linkTo",
        type: "string",
      },
      {
        name: "variant",
        type: "string",
        enum: ["primary", "secondary", "tertiary"],
        defaultValue: "primary",
      },
      {
        name: "openInNewTab",
        friendlyName: "Open in new tab",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "disabled",
        type: "boolean",
      },
      {
        name: "destructive",
        type: "boolean",
      },
      {
        name: "small",
        type: "boolean",
      },
      {
        name: "tertiaryColor",
        type: "color",
      },
      {
        name: "replace",
        type: "boolean",
      },
      {
        name: "eventKeyOnClick",
        type: "string",
      },
      {
        name: "eventParams",
        type: "list",
        subFields: [
          {
            name: "param",
            type: "string",
          },
        ],
      },
    ],
  });
};
